import { Routes } from '@angular/router';
import { EspecialidadesContent } from './especialidades-content';
import { DashboardEspecialidades } from '@/features/registro/especialidades/dashboard-especialidades/dashboard-especialidades';

const rootPath = 'especialidades';

/**
 * Define as rotas do módulo de Especialidades:
 * - /especialidades: Rota principal que carrega o layout `EspecialidadesContent`.
 * - Rota padrão ('') -> `DashboardEspecialidades`
 * - Rota 'relatorios' -> `Relatorios`
 */
export const especialidadesRoutes: Routes = [
    {
        path: rootPath,
        component: EspecialidadesContent,
        children: [{ path: '', component: DashboardEspecialidades }]
    }
];
